export default __webpack_public_path__ + "static/media/associate1.a6d0a283.svg";